import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UsersService} from "../../../services/users.service";
import {SnackService} from "../../../services/snack.service";
import {User} from "../../../model/user";
import {merge} from "lodash-es";
import {Permission} from "../../../model/permission";
import {PermissionsService} from "../../../services/permissions.service";
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'aw-user-permissions-form',
  templateUrl: './user-permissions-form.component.html',
  styleUrls: ['./user-permissions-form.component.scss']
})
export class UserPermissionsFormComponent implements OnInit {

  @Output() done: EventEmitter<User> = new EventEmitter();

  loadingPermissions = false;

  permissions: Permission[] = [];
  loggedUser: User;
  currentPermissionsNames: string[] = [];
  loadingPermissionsNames: string[] = [];
  protected readonly console = console;

  constructor(
    private userService: UsersService,
    private permissionService: PermissionsService,
    private snackService: SnackService,
    private authService: AuthService,
  ) {

  }

  _user = new User();

  @Input() set user(value: User) {
    this._user = merge(new User(), value);
    this.currentPermissionsNames = [...this._user.permissions.map(value => value.name)];
  }

  ngOnInit(): void {
    this.loadPermissions();
  }


  comparePermissions = (a: Permission, b: Permission): boolean => {
    return a && b ? a.id === b.id : a === b;
  };


  togglePermission(permissionName: string): void {
    if (permissionName === 'admin' && this._user.id === this.authService.loggedUser()?.id) {
      this.snackService.info(`You cannot remove the admin permission from yourself!`,);
      return;
    }
    if (permissionName === 'customer' && this.currentPermissionsNames.includes('admin')) {
      this.snackService.info(`Cannot assign customer, revoke admin permission first.`);
      return;
    }
    if (permissionName === 'admin' && this.currentPermissionsNames.includes('customer')) {
      this.snackService.info(`Cannot assign admin, revoke customer permission first.`);
      return;
    }

    this.loadingPermissionsNames = [...this.loadingPermissionsNames, permissionName];

    if (this.currentPermissionsNames.includes(permissionName)) {

      this.userService
        .deleteUserPermissions(this._user.id, [permissionName])
        .subscribe(
          () => {
            this.currentPermissionsNames = [...(this.currentPermissionsNames.filter(value => value != permissionName))];
            this.snackService.success(`${permissionName} permission revoked!`);
            this.loadingPermissionsNames = [...(this.loadingPermissionsNames.filter(value => value != permissionName))];
          },
          () => {
            this.snackService.error(`Error while revoking ${permissionName} permission!`);
            this.loadingPermissionsNames = [...(this.loadingPermissionsNames.filter(value => value != permissionName))];
          }
        );

    } else {

      this.userService
        .addUserPermissions(this._user.id, [permissionName])
        .subscribe(
          () => {
            this.currentPermissionsNames = [...this.currentPermissionsNames, permissionName];
            this.snackService.success(`${permissionName} permission assigned!`);
            this.loadingPermissionsNames = [...(this.loadingPermissionsNames.filter(value => value != permissionName))];
          },
          () => {
            this.snackService.error(`Error while assigning ${permissionName} permission!`);
            this.loadingPermissionsNames = [...(this.loadingPermissionsNames.filter(value => value != permissionName))];
          }
        );
    }

  }

  private loadPermissions(): void {
    this.loadingPermissions = true;

    this.permissionService.getAllPermissions()
      .subscribe(perms => {
        this.permissions = perms;
        this.loadingPermissions = false;
      });
  }
}
